import { forgetPassword } from '@/store/actions';
import { createSlice } from '@reduxjs/toolkit';

const initialForgetState = {
  isLoading: false,
};

export const forgetSlice = createSlice({
  name: 'forgetPassword',
  initialState: initialForgetState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(forgetPassword.pending, (state: any) => {
         
        state.isLoading = true;
      })
      .addCase(forgetPassword.fulfilled, (state: any, { payload }: any) => {
 

        state.isLoading = false;
      })
      .addCase(forgetPassword.rejected, (state: any) => {
 
        state.isLoading = true;
      });
  },
});

// Export the action creator and reducer
export default forgetSlice.reducer;
